import {
    ComponentInjector,
} from '@atypon/ui-utils';
import BaseShowRecommended, {
    ShowRecommendedElements,
    ShowRecommendedSelectors,
    ShowRecommendedTexts,
    ShowRecommendedClassList
}  from 'ui-base/widgets/show-recommended/js/show-recommended'

class Texts extends ShowRecommendedTexts {
}

class ClassList extends ShowRecommendedClassList {
}

class Selectors extends ShowRecommendedSelectors {

}

class Elements extends ShowRecommendedElements {
}

@ComponentInjector(Selectors, Elements, ClassList, Texts)
class ShowRecommended extends BaseShowRecommended {
    addEventListeners() {
        super.addEventListeners();
        this.domUtils.addEventListener(this.wrapper, 'showRecommended:loaded', () => {
            if (this.domUtils.getElement('.slideShow', this.wrapper)) {
                try {
                    UX.slider.init();
                } catch (e) {
                    console.log(e);
                }
            }
        })
    }
}

export default ShowRecommended;